import { getEditor, isEnabled } from '../composables/editorsMap';
import SelectOptions from '../menuItemComponents/SelectOptions.vue';
import { ALargeSmall } from 'lucide-vue-next';
export const getfontSizeOptions = (id: string, fontSizeOptions) => {
  const editor = getEditor(id)?.value;
  return {
    disabled: !isEnabled(id, 'font_size'),
    icon: ALargeSmall,
    title: 'גודל טקסט',
    type: 'select',
    component: SelectOptions,
    props: {
      type: 'fontSize',
      options: fontSizeOptions(),
      action: option => {
        editor.chain().focus()[option.actionMethod](option.attributes).run();
      },
    },
  };
};
